import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'

import csatAgenciesTypes from './action-types'
import { fetchCsatAgenciesList } from './api'

export default function* root() {
  yield takeEveryApiCall(csatAgenciesTypes.ENTITIES_FETCH_BEGIN, fetchCsatAgenciesList)
}
